export default {
    data() {
        return {
            loading: true,
            availablePerPageOptions: [10, 25, 50, 100],
            filterDebounce: 500,
            totalItems: 0,
            query: {
                page: 1,
                perPage: 10,
                filter: null,
                sortBy: 'created_at',
                sortDesc: false
            }
        }
    },
    methods: {
        buildQuery(query = this.query) {
            const queries = []
            const esc = encodeURIComponent;

            Object.keys(query).map(item => {
                if (this.query[item] && item !== 'currentPage') {
                    queries.push(esc(item) + '=' + esc(query[item]))
                }
            })

            return queries.join('&')
        },
    },
}
